import * as React from "react";
import type { SVGProps } from "react";

const FacilityRestaurant = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M15.8251 11.507L15.8346 12.5H12.0846C11.8545 12.5 11.668 12.3135 11.668 12.0833V9.42849C11.668 5.60199 13.5292 2.5 15.8251 2.5L15.8346 2.50957L15.827 2.5V12.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.332 12.5H15.832V16.25C15.832 16.9404 15.2724 17.5 14.582 17.5V17.5C13.8917 17.5 13.332 16.9404 13.332 16.25V12.5Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.2487 8.66699V10.8337"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="5"
      y="10.833"
      width="2.5"
      height="6.66667"
      rx="1.25"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.2487 6.24967V2.70801"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33464 2.5V7C8.33464 7.92047 7.58844 8.66667 6.66797 8.66667H5.83464C4.91416 8.66667 4.16797 7.92047 4.16797 7V2.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33464 6.24967H4.16797"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityRestaurant.displayName = "FacilityRestaurant";

export default FacilityRestaurant;
